import React from 'react';
import { useSearchParams, useLocation } from 'react-router-dom';
import './App.css';
import AudienceListApp from './components/audience-list/AudienceListApp';
import AudienceBuilderApp from './components/audience-builder/AudienceBuilderApp';
import { PromptApp } from './components/PromptApp';

type Props = {
  fallbackMode: string;
};

const App: React.FC<Props> = ({ fallbackMode }) => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  
  const modeFromQuery = searchParams.get('mode');
  const pathSegments = location.pathname.toLowerCase().split('/').filter(Boolean);
  const modeFromPath = pathSegments.includes('audience-list') || pathSegments.includes('audiences')
    ? 'list'
    : pathSegments.includes('audience-builder') || pathSegments.includes('builder')
      ? 'builder'
      : pathSegments.includes('prompt')
        ? 'prompt'
        : null;
  
  const mode = (modeFromQuery ?? modeFromPath ?? fallbackMode).toLowerCase();
  const normalizedMode = mode === 'data' ? 'list' : mode === 'audience-builder' ? 'builder' : mode;

  return (
    <>
      {normalizedMode === 'list' ? <AudienceListApp /> : null}
      {normalizedMode === 'prompt' ? <PromptApp /> : null}
      {normalizedMode === 'builder' ? <AudienceBuilderApp /> : null}
      {normalizedMode !== 'list' && normalizedMode !== 'prompt' && normalizedMode !== 'builder' && (
        <div>Not supported {mode}</div>
      )}
    </>
  );
};


export default App;
